const payoffColors = {
  black: '#001239',
  white: '#FFFFFF',
  blue: '#00b2ff',
  indigo: '#6610f2',
  purple: '#6f42c1',
  pink: '#f2117a',
  red: '#ff2c5c',
  orange: '#fd7e14',
  yellow: '#fdfa38',
  green: '#11e07c',
  teal: '#20c997',
  cyan: '#17a2b8',
  gray: '#667188',
  grayDark: '#001239',
  primary: '#f2117a',
  secondary: '#667188',
  success: '#11e07c',
  info: '#00b2ff',
  warning: '#fdfa38',
  danger: '#ff2c5c',
  light: '#e6e7eb',
  dark: '#334161'
};

export { payoffColors as default, payoffColors };
//# sourceMappingURL=PayoffColors.js.map
